import { getSignerStatusLabel } from 'app/shared/modules/DisclosureDelivery/DisclosureDelivery.utils';
import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { HORIZONTAL_ALIGNMENT } from 'constants/ui';
import { alwaysTrue } from 'utils/data';

const formatDate = value => (value ? dayjs(value).format(COMMON_DATETIME_FORMAT) : 'N/A');

const getDateColumn = ({ label, path, tooltip }) => ({
  label,
  align: HORIZONTAL_ALIGNMENT.LEFT,
  sort: true,
  sortBy: path,
  tooltip,
  renderContentAsText: alwaysTrue,
  content: item => formatDate(item[path]),
});

export const getLoanBundleHistoryTableConfig = ({ isSignable }) => ({
  signerFullName: {
    label: 'Recipient Name',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    sort: true,
  },
  status: {
    label: 'Delivery Status',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    sort: true,
    renderContentAsText: alwaysTrue,
    content: ({ status, consentedDate }) =>
      getSignerStatusLabel(status, { isSignable, consentedDate }).title,
  },
  generated: getDateColumn({
    label: 'Generated',
    path: 'sentDate',
    tooltip: 'The disclosures were generated',
  }),
  sent: getDateColumn({
    label: 'Sent',
    path: 'sentDate',
    tooltip: 'The disclosures were emailed to the borrower',
  }),
  openedDate: getDateColumn({
    label: 'Opened',
    path: 'openedDate',
    tooltip: 'The borrower opened the email',
  }),
  consentedDate: getDateColumn({
    label: 'Read',
    path: 'consentedDate',
    tooltip: 'The borrower viewed the document',
  }),
  signedDate: getDateColumn({
    label: 'E-Signed',
    path: 'signedDate',
    tooltip: 'The borrower signed the documents',
  }),
  acknowledgedDate: getDateColumn({ label: 'Acknowledged', path: 'acknowledgedDate' }),
});
